<template>
  <div class="game-container">
    <div class="monster-slayer">
      <Banner></Banner>
      <ExitButton></ExitButton>
      <section class="row">
        <Character :character="player" type="player"></Character>
        <Character :character="monster" type="monster"></Character>
      </section>

      <transition :css="false" @enter="flipIn" @leave="flipOut" mode="out-in">
        <section class="row ms-controls" v-if="!gameActive" key="startControls">
          <div class="col-sm-12">
            <button id="start-game" @click="startGame">START NEW GAME</button>
          </div>
        </section>
        <section class="row ms-controls" v-else key="playControls">
          <div class="col-sm-12">
            <button id="attack" @click="playerAttack(false)">ATTACK</button>
            <button id="special-attack" @click="playerAttack(true)">
              SPECIAL ATTACK
            </button>
            <button id="heal" @click="playerHeal">HEAL</button>
            <button id="give-up" @click="resetGame">GIVE UP</button>
          </div>
        </section>
      </transition>

      <section class="row ms-log" v-if="combatLog.length > 0">
        <CombatLog :combatLog="combatLog"></CombatLog>
      </section>
    </div>
  </div>
</template>

<script>
import ExitButton from "./components/ui/ExitButton.vue";
import Banner from "./components/ui/Banner.vue";
import CombatLog from "./components/CombatLog.vue";
import Character from "./components/character/Character.vue";
import { transitions } from "../../animations/mixins/TransitionMixin.js";

export default {
  components: { Character, CombatLog, Banner, ExitButton },

  name: "MonsterHunter",
  mixins: [transitions],
  data() {
    return {
      gameActive: false,
      player: {
        name: "YOU",
        health: 100,
        maxHealth: 100,
        damage: {
          min: 5,
          max: 15,
          special: 15
        },
        heal: 20
      },
      monster: {
        name: "MONSTER",
        health: 100,
        maxHealth: 100,
        damage: {
          min: 5,
          max: 20
        }
      },
      combatLog: [],
      logIdx: 0,
      combatLogSize: 10,
      hueShift: 180
    };
  },
  methods: {
    startGame() {
      this.player.health = 100;
      this.monster.health = 100;
      this.combatLog = [];
      this.gameActive = true;
      this.logIdx = 0;
    },

    resetGame() {
      this.player.health = 100;
      this.monster.health = 100;
      this.combatLog = [];
      this.gameActive = false;
      this.logIdx = 0;
    },

    randomDamage(min, max) {
      return Math.floor(Math.random() * (max - min + 1)) + min;
    },

    playerAttack(isSpecial) {
      let playerDamage = this.randomDamage(
        this.player.damage.min,
        this.player.damage.max
      );
      if (isSpecial) {
        playerDamage += this.player.damage.special;
      }

      this.monster.health -= playerDamage;

      this.logAction(
        "player-attack",
        "Player attacked the monster for",
        playerDamage
      );

      this.monsterAttack();
    },

    monsterAttack() {
      let monsterDamage = this.randomDamage(
        this.monster.damage.min,
        this.monster.damage.max
      );

      this.player.health -= monsterDamage;

      this.logAction(
        "monster-attack",
        "Monster attacked the player for",
        monsterDamage
      );
    },

    playerHeal() {
      this.player.health += this.player.heal;

      if (this.player.health > 100) {
        let healValue = this.player.heal - (this.player.health - 100);
        this.player.health = 100;

        this.logAction("heal", "Player healed themself for", healValue);
      } else {
        this.logAction("heal", "Player healed themself for", this.player.heal);
      }

      this.monsterAttack();
    },

    logAction(actionType, actionDescr, actionValue) {
      let action = {
        id: this.logIdx,
        type: actionType,
        descr: actionDescr,
        value: actionValue
      };
      this.combatLog.push(action);
      this.logIdx++;

      if (this.combatLog.length > this.combatLogSize) {
        this.combatLog.shift();
      }
    },

    notifyWinLoss(msg) {
      if (confirm(msg)) {
        this.startGame();
      } else {
        this.resetGame();
      }
    }
  },

  watch: {
    player: {
      handler() {
        if (this.player.health <= 0) {
          this.player.health = 0;
          this.notifyWinLoss("You lost. 😞 Start new game?");
        }
      },
      deep: true
    },

    monster: {
      handler() {
        if (this.monster.health <= 0) {
          this.monster.health = 0;
          this.notifyWinLoss("You won! 😁 Start new game?");
        }
      },
      deep: true
    }
  }
};
</script>

<style lang="scss">
@import "./scss/monsterslayer.scss";
</style>
